import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/repos/ReposFeedClient.tsx");
